var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82933 9.68531C5.84567 9.523 5.82379 9.35912 5.76544 9.20677C5.7071 9.05443 5.61391 8.91786 5.49333 8.80798L3.00266 5.78531V5.33331H10.7333L16.7093 18.54L21.9627 5.33331H29.3333V5.78531L27.204 7.83998C27.1138 7.90964 27.0442 8.0025 27.0026 8.10865C26.961 8.21479 26.9491 8.33024 26.968 8.44265V23.5546C26.9491 23.6671 26.961 23.7825 27.0026 23.8886C27.0442 23.9948 27.1138 24.0877 27.204 24.1573L29.284 26.2133V26.6666H18.8253V26.2146L20.98 24.108C21.192 23.8946 21.192 23.832 21.192 23.5066V11.2906L15.2027 26.616H14.3947L7.42133 11.2906V21.5626C7.364 21.9933 7.50666 22.4293 7.808 22.7413L10.6093 26.1653V26.616H2.66666V26.1653L5.46666 22.7413C5.61481 22.5867 5.72477 22.3996 5.78774 22.195C5.8507 21.9903 5.86495 21.7738 5.82933 21.5626V9.68531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedium);
export default __webpack_public_path__ + "static/media/icon_medium.f52d24e4711a3d920b7e3492b083d98f.svg";
export { ForwardRef as ReactComponent };